import { HeaderNavTab } from '@bessemercws/components';
import {
  useGetClientAddtionalServicesQuery,
  useGetEmulatorClientAddtionalServicesQuery,
  User,
} from '@bessemercws/graphql';
import { useClientContext } from '@bessemercws/providers';

import { CONSOLIDATED_REPORTING_URI_1, CONSOLIDATED_REPORTING_URI_2 } from '#/constants';
import { useBillPay } from '../hooks';

export const useAdditionalServices = () => {
  const { showBillPay } = useBillPay();
  const { isAdvisor, selectedClient, authSessionToken } = useClientContext();
  const buildAdditionalServices = (data: User, hasConsolidatedReporting: boolean | undefined): HeaderNavTab[] => {
    const additionalServicesTemp = new Set<HeaderNavTab>();

    if (data?.additionalServices?.billPay) {
      const billPayItem = { label: 'Bill Pay', onClick: () => showBillPay(data) };
      additionalServicesTemp.add(billPayItem);
    }

    if (hasConsolidatedReporting || data?.additionalServices?.hasConsolidatedReporting) {
      const consolidatedReportingURL = `${CONSOLIDATED_REPORTING_URI_1}${authSessionToken}${CONSOLIDATED_REPORTING_URI_2}`;
      const consolidatedReportingItem = {
        label: 'Consolidated Reporting',
        href: consolidatedReportingURL,
      };
      additionalServicesTemp.add(consolidatedReportingItem);
    }
    return Array.from(additionalServicesTemp);
  };
  const buildAdditionalServicesTab = (additionalServices: HeaderNavTab[], isTabDisabled: boolean): HeaderNavTab => {
    if (additionalServices.length === 1) {
      return additionalServices[0];
    }
    return {
      label: 'Additional Services',
      children: additionalServices,
      skip: additionalServices?.length <= 0,
      disabled: isTabDisabled,
    };
  };

  const useAdditionalServicesQuery = () => {
    const clientResponse = useGetClientAddtionalServicesQuery({ skip: isAdvisor });
    const emulatorResponse = useGetEmulatorClientAddtionalServicesQuery({
      variables: { userId: selectedClient ?? '' },
      skip: !selectedClient || !isAdvisor,
    });
    if (isAdvisor) {
      const { data, loading } = emulatorResponse;
      return [data?.advisor?.client, loading];
    }
    const { data, loading } = clientResponse;
    return [data?.viewer, loading];
  };

  return { buildAdditionalServices, buildAdditionalServicesTab, useAdditionalServicesQuery };
};

export default useAdditionalServices;
